<template>
  <v-container fluid p-0 m-0>
    <v-layout row style="position: relative;">
      <v-container style="z-index: 2;">
        <v-layout row justify-content-center align-center>
          <v-flex v-if="herb_image" text-center xl3 md3 sm3 xs12>
            <router-link to="/">
              <img
                :src="$env.imagesPATH.upload + herb_image"
                alt="Herb w nagłówku"
                class="flex-fill img-fluid m-auto header-logo"
              />
            </router-link>
          </v-flex>
          <v-flex fill-height v-if="$vuetify.breakpoint.mdAndUp"  xl9 md9 sm9> 
            <v-layout column align-center fill-height>
              <v-flex>
                <h2 v-html="title_first_line" v-if="title_first_line" class="headline"></h2>
              </v-flex>
              <v-flex class="code" v-if="title_second_line">
                <h5 class="headline text-center" v-html="title_second_line"></h5>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
      <div
        class="bg-header"
        :class="{ 'high_contrast': this.$store.state.high_contrast }"
        v-bind:style="[header_image ? { 'background-image': 'url(' + $env.imagesPATH.upload + header_image + ')' } : { 'background-image': 'url('+ $env.imagesPATH.default + 'header.jpg)' }]"
      ></div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "rHeader",
  props: {
    title_first_line: null,
    title_second_line: null,
    herb_image: null,
    header_image: null,
    globals: null
  }
};
</script>

<style scoped>
.bg-header {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.high_contrast {
  background-color: black;
  opacity: 0.3;
}

.code {
  border-radius: 25px;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 0.5rem;
  margin: 0 !important;
}

.headline{
  color: rgb(255, 255, 255); 
  mix-blend-mode: difference;
  margin: 0;
}

.header-logo{
  /* width: auto; */
  /* height: 100px;
  max-height: 100px; */
}

</style>